// src/api/client.js
import axios from "axios";
import { RealLoadingBar } from "../utils/loadingBar";

// 로컬
// export const BASE =
//     process.env.REACT_APP_API_URL ||
//     (typeof window !== "undefined"
//         ? `${window.location.protocol}//${window.location.hostname}:8000`
//         : "http://localhost:8000");

// 배포용
export const BASE =
    process.env.REACT_APP_API_URL ||
    (typeof window !== "undefined"
        ? `${window.location.origin}/api`
        : "http://localhost:8000");

export const api = axios.create({
    baseURL: BASE,
    withCredentials: true,
});

export function getAccessToken() {
    try { return localStorage.getItem("token") || sessionStorage.getItem("token") || ""; }
    catch { return ""; }
}
export function setAccessToken(t) {
    try { localStorage.setItem("token", t ?? ""); } catch { }
}
export function clearAccessToken() {
    try {
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
    } catch { }
    // axios 기본 헤더를 쓰는 경우 방지
    delete api.defaults.headers.common?.Authorization;
}
export function clearAllAuthState() {
    clearAccessToken();
    // 다른 키를 잠깐이라도 썼을 여지 제거
    try {
        ["access_token", "refresh_token"].forEach(k => {
            localStorage.removeItem(k);
            sessionStorage.removeItem(k);
        });
    } catch { }
}

export const absUrl = (u) => {
    if (!u) return "";
    if (/^(https?:|blob:|data:)/i.test(u)) return u;
    return `${BASE}${u.startsWith("/") ? u : `/${u}`}`;
};

function authHeader() {
    const t = getAccessToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
}

async function refreshAccessToken() {
    const res = await fetch(`${BASE}/auth/refresh`, {
        method: "POST",
        credentials: "include",
    });
    if (!res.ok) {
        clearAccessToken();
        return false;
    }
    const data = await res.json();
    if (!data?.access_token) {
        clearAccessToken();
        return false;
    }
    setAccessToken(data.access_token);
    return true;
}

export async function logoutLocal() {
    clearAllAuthState();
}

export default async function request(path, options = {}, _retried = false) {
    const { method = "GET", body, headers = {}, params, ...rest } = options;

    const jobId = _retried
        ? null
        : `api:${method.toUpperCase()} ${path}:${Date.now()}:${Math.random().toString(36).slice(2, 7)}`;
    if (jobId) RealLoadingBar.begin(jobId, 0);

    try {
        const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
        const isJSONHeader =
            (headers["Content-Type"] || headers["content-type"] || "").includes("application/json");

        const shouldStringify =
            body !== undefined &&
            !isFormData &&
            (isJSONHeader || typeof body === "object") &&
            typeof body !== "string" &&
            !(body instanceof Blob) &&
            !(body instanceof ArrayBuffer);

        const finalBody =
            method.toUpperCase() === "GET" || method.toUpperCase() === "HEAD"
                ? undefined
                : shouldStringify
                    ? JSON.stringify(body)
                    : body;

        const url = new URL(`${BASE}${path}`);
        if (params && typeof params === "object") {
            Object.entries(params).forEach(([k, v]) => {
                if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
            });
        }

        const res = await fetch(url.toString(), {
            method,
            body: finalBody,
            headers: {
                ...(!isFormData && (isJSONHeader || typeof body === "object") && finalBody
                    ? { "Content-Type": "application/json" }
                    : {}),
                ...headers,
                ...authHeader(),
            },
            credentials: "include",
            ...rest,
        });

        const text = await res.text();
        let data;
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            data = text;
        }

        if (res.status === 401 && !_retried) {
            const ok = await refreshAccessToken();
            if (ok) return request(path, options, true);
            clearAllAuthState();
        }

        if (!res.ok) {
            const msg =
                (data && (data.detail || data.message)) ||
                `${res.status} ${res.statusText}` ||
                "요청 실패";
            const err = new Error(msg);
            err.status = res.status;
            err.data = data;
            throw err;
        }
        return data;
    } finally {
        if (jobId) RealLoadingBar.end(jobId);
    }
}
